import React, { useState } from "react";
import Collapsible from "react-collapsible";
import styled from "styled-components";

import banner from "images/track_guides/tips_banner.png";
import downArrow from "images/chevron_down.svg";

const Wrapper = styled.div`
	.Collapsible {
		margin-bottom: 20px;
	}
`;

const Title = styled.h3`
	margin: 5px 0 -15px 0;
	padding: 14px;
	border: 2px solid #979797;
	color: #cf0207;

	&:after {
		content: url(${downArrow});
		float: right;
	}

	.Collapsible__trigger.is-open & {
		background-color: #cf0207;
		border-color: #cf0207;
		color: white;
	}

	.Collapsible__trigger.is-open &:after {
		filter: brightness(100);
		transform: rotate(180deg);
	}
`;

const List = styled.ul`
	line-height: 1.5;
	color: #012126;

	li {
		margin-bottom: 15px;
	}

	li::marker {
		color: #01788a;
	}
`;

const Banner = styled.img`
	width: 100%;
`;

const handleClick = (setState, currentTurn, clickedTurn) => {
	const activeTurn = currentTurn == clickedTurn ? null : clickedTurn;

	setState(activeTurn);
};

const TrackTips = ({ turns, className }) => {
	const firstTurn = turns[0]?.number;
	const [activeTurn, setActiveTurn] = useState(firstTurn);

	return (
		<Wrapper className={className}>
			<Banner src={banner} />
			{turns.map((turn, index) => (
				<Collapsible
					trigger={<h3 className="TGh3btn">Turn {turn.name || turn.number}</h3>}
					transitionTime={200}
					open={turn.number == activeTurn}
					accordionPosition={turn.number}
					handleTriggerClick={(number) => {
						handleClick(setActiveTurn, activeTurn, number);
					}}
				>
					<List>
						{turn.tips.map((tip) => (
							<li className="TGli">{tip}</li>
						))}
					</List>
				</Collapsible>
			))}
		</Wrapper>
	);
};

export default TrackTips;
